const routes = {
  path: '/enterprise',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '企业管理',
    permission: 'company',
    icon: 'iconqiyeguanli'
  },
  children: [
    {
      path: 'department/member/list',
      name: 'FirmMemberList',
      component: () => import('@/views/firm/member/index.vue'),
      meta: {
        title: '部门人员',
        permission: 'company.admin',
      }
    },
    {
      path: 'role/list',
      name: 'FirmRoleList',
      component: () => import('@/views/firm/role/list.vue'),
      meta: {
        title: '角色管理',
        permission: 'company.role',
      }
    },
    {
      path: 'notice/list',
      name: 'FirmNoticeList',
      component: () => import('@/views/firm/notice/list.vue'),
      meta: {
        title: '公告管理',
        permission: 'company.announcement',
      }
    },
    // {
    //   path: 'operate/list',
    //   name: 'FirmOperate',
    //   component: () => import('@/views/firm/operate/list.vue'),
    //   meta: {
    //     title: '操作日志',
    //     permission: 'action-log',
    //   }
    // },
  ]
}
export default routes;